import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Container,
  Typography,
  CircularProgress,
  Box,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  IconButton,
  Snackbar,
  Badge
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import MuiAlert from '@mui/material/Alert';
import DashboardLayout from '../../Sidebar/DashboardLayout';
import GenericTable from '../../../commun/GenericTable';
import Pagination from '../../../commun/Pagination';
import './contactMessages.css';
import Chatbox from '../../../commun/ChatBox';

const ContactMessages = () => {
  const [displayMode, setDisplayMode] = useState('table');

  const [messages, setMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [newAlert, setNewAlert] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [page, setPage] = useState(1);
  const userRole = localStorage.getItem('userType');

  const messagesPerPage = 4;
  const paginatedMessages = messages.slice((page - 1) * messagesPerPage, page * messagesPerPage);

  useEffect(() => {
    fetchMessages();
    const interval = setInterval(checkNewMessages, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchMessages = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/contact-messages`);
      setMessages(res.data);
      const unread = res.data.filter(msg => !msg.lu).length;
      setUnreadCount(unread);
    } catch (err) {
      console.error("Erreur lors du chargement des messages", err);
      setMessages([]);
    }
  };

  const checkNewMessages = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/contact-messages`);
      if (res.data.length > messages.length) {
        setMessages(res.data);
        setNewAlert(true);
        const unread = res.data.filter(msg => !msg.lu).length;
        setUnreadCount(unread);
      }
    } catch (err) {
      console.error("Erreur lors de la vérification des nouveaux messages", err);
    }
  };

  const handleView = async (row) => {
    setSelectedMessage(row);
    if (!row.lu) {
      try {
        await axios.patch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/contact-messages/${row._id}/lu`);
        fetchMessages(); // Refresh to update `lu`
      } catch (err) {
        console.error('Erreur lors de la mise à jour du message comme lu.');
      }
    }
  };

  const handleClose = () => {
    setSelectedMessage(null);
  };

  const columns = [
    {
      key: 'lu',
      label: '',
      render: (_, row) =>
        !row.lu ? <span className="dot-unread" title="Non lu" /> : null
    },
    { key: 'nom', label: 'Nom' },
    {
      key: 'email',
      label: 'Email',
      render: (val) => <a href={`mailto:${val}`} className="contact-link">{val}</a>
    },
    {
      key: 'telephone',
      label: 'Téléphone',
      render: (val) => <a href={`tel:${val}`} className="contact-link">{val}</a>
    },
    { key: 'objet', label: 'Objet' },
    { key: 'message', label: 'Message' },
    {
      key: 'createdAt',
      label: 'Date',
      render: (val) => new Date(val).toLocaleString()
    },
    {
      key: 'actions',
      label: '',
      render: (_, row) => (
        <IconButton onClick={() => handleView(row)}>
          <Badge color="error" variant="dot" invisible={row.lu}>
            <VisibilityIcon color="primary" />
          </Badge>
        </IconButton>
      )
    }
  ];

  return (
    <DashboardLayout>
      <Container maxWidth="lg">
        <Box className="contact-header">
          <Typography variant="h4" className="contact-title">
            Demandes de contact
          </Typography>
          {unreadCount > 0 && (
            <Badge badgeContent={unreadCount} color="error" sx={{ ml: 2 }} />
          )}
        </Box>

        {messages.length === 0 ? (
          <Box className="contact-loading">
            <CircularProgress />
          </Box>
        ) : (
          <Paper elevation={1} className="contact-table">
            <GenericTable columns={columns} data={paginatedMessages}   displayMode={displayMode}
  setDisplayMode={setDisplayMode} />
            
            <Pagination
              page={page}
              setPage={setPage}
              totalItems={messages.length}
            />
          </Paper>
        )}

        <Dialog open={!!selectedMessage} onClose={handleClose} maxWidth="sm" fullWidth>
          <DialogTitle>Détails du message</DialogTitle>
          <DialogContent>
            <DialogContentText><strong>Nom :</strong> {selectedMessage?.nom}</DialogContentText>
            <DialogContentText><strong>Email :</strong> <a href={`mailto:${selectedMessage?.email}`}>{selectedMessage?.email}</a></DialogContentText>
            <DialogContentText><strong>Téléphone :</strong> <a href={`tel:${selectedMessage?.telephone}`}>{selectedMessage?.telephone}</a></DialogContentText>
            <DialogContentText><strong>Objet :</strong> {selectedMessage?.objet}</DialogContentText>
            <DialogContentText><strong>Message :</strong> {selectedMessage?.message}</DialogContentText>
            <DialogContentText><strong>Date :</strong> {new Date(selectedMessage?.createdAt).toLocaleString()}</DialogContentText>
          </DialogContent>
        </Dialog>

        <Snackbar
          open={newAlert}
          autoHideDuration={5000}
          onClose={() => setNewAlert(false)}
        >
          <MuiAlert onClose={() => setNewAlert(false)} severity="info" sx={{ width: '100%' }}>
            Nouvelle demande de contact reçue.
          </MuiAlert>
        </Snackbar>
      </Container>
      {userRole !== 'agent' && <Chatbox userRole={userRole} />}
    </DashboardLayout>
  );
};

export default ContactMessages;
